import { combineReducers } from 'redux';

import {
  TOUR_CHANGED,
  TOUR_DATES_CHANGED
} from '../constants/editTourConstants';

const csrfToken = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const team = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const currentUser = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const tour = (state = {}, action) => {
  switch (action.type) {
    case TOUR_CHANGED:
      return action.tour;
    default:
      return state;
  }
};

const tourDates = (state = [], action) => {
  switch (action.type) {
    case TOUR_DATES_CHANGED:
      return action.tourDates;
    default:
      return state;
  }
};

const editTourReducer = combineReducers({
  csrfToken,
  team,
  currentUser,
  tour,
  tourDates
});

export default editTourReducer;
